module.exports = __webpack_public_path__ + "static/img/school-14.b7fead5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/school-14.png
// module id = mBY+
// module chunks = 1